// Rolls number d sides dice, or number d6s if only one parameter provided, 1d6 if no parameters
export default function roll(number = 1, sides = 6) {
  let result = 0;
  for (let times = 0; times < number; times++) {
    const roll = Math.floor(Math.random() * sides) + 1;
    result += roll;
  }
  return result;
}
